import React, { createContext, useContext, useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

const BrandingContext = createContext({});

export const BrandingProvider = ({ children }) => {
  const [branding, setBranding] = useState({
    app_name: 'Mercury Dry Cleaners',
    logo_icon: 'Droplet',
    logo_url: '',
    seo_title: 'Mercury Dry Cleaners',
    seo_description: 'Professional Garment Care'
  });

  const refreshBranding = async () => {
    try {
      const { data, error } = await supabase
        .from('app_settings')
        .select('value')
        .eq('key', 'seo_branding')
        .maybeSingle();

      if (error) {
        console.error('Error fetching branding from DB:', error.message);
        return;
      }

      if (data?.value) {
        setBranding(prev => ({ ...prev, ...data.value }));

        // Update DOM for SEO
        if (data.value.seo_title) {
          document.title = data.value.seo_title;
        }

        if (data.value.seo_description) {
          let metaDesc = document.querySelector('meta[name="description"]');
          if (!metaDesc) {
            metaDesc = document.createElement('meta');
            metaDesc.name = 'description';
            document.head.appendChild(metaDesc);
          }
          metaDesc.setAttribute('content', data.value.seo_description);
        }

        // Update Favicon if provided using logo_url
        if (data.value.logo_url) {
          let link = document.querySelector("link[rel~='icon']");
          if (!link) {
            link = document.createElement('link');
            link.rel = 'icon';
            document.head.appendChild(link);
          }
          link.href = data.value.logo_url;
        }
      }
    } catch (err) {
      console.error('Failed to load branding:', err);
    }
  };

  useEffect(() => {
    refreshBranding();
  }, []);

  return (
    <BrandingContext.Provider value={{ branding, refreshBranding }}>
      {children}
    </BrandingContext.Provider>
  );
};

export const useBranding = () => useContext(BrandingContext);